import React from 'react'

const MeseeIntroduction = () => {
    return (
        <>
            <section id="first" className="about bg2 ">
                <div className="container">
                    <div className="section-title">
                        <br />
                        <h2 className="animated fadeInDown">Introduction</h2>
                        <div className="bar" />
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className=" cd-intro-content bouncy shadow p-4 animated swing">
                                <div className="row">
                                    <div className="col-md-8 allpara pl-3">
                                        <h3 className="text-left mesee-mg animated fadeInUp ease-out-circ d2 a-1 f2 fw3 heading">
                                            MESEE
                                        </h3>
                                        <p>
                                            We are the first Rwanda’s and regional home services market
                                            place.
                                        </p>
                                        <p>Cleaning</p>
                                        <p></p>
                                        <p>Handymen</p>
                                        <p></p>
                                        <p>Plumbing</p>
                                        <p></p>
                                        <p>Electrical</p>
                                        <p></p>
                                        <p>Lawn mowing</p>
                                        <p></p>
                                        <p>Home repairs</p>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="video-responsive mt-5">
                                            <iframe
                                                width="100%"
                                                height={168}
                                                src="https://www.youtube.com/embed/F63Fph3rZII"
                                                frameBorder={0}
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen=""
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 allpara p-0">
                                    <p>
                                        Our multisided platform connects clients in need of home services
                                        with vetted, trained, skilled and certified professional service
                                        providers to help customers with home chores. On the other hand we
                                        help in creating self-employment, be it for individual
                                        professionals or companies with limited or no start capital by
                                        connecting them with customers in structured way for both sides to
                                        benefit.
                                    </p>
                                    <h6 className="pt-2 text-left">WHY MESEE</h6>
                                    <p>
                                        Easiest way to book trusted and skilled home services providers in
                                        town, whether you are at your home or away in minutes. Same day
                                        appointments or Pick-up a time slot that works better for you
                                        Highly trained and skilled local professionals Back-ground checked
                                        and vetted, thus trusted Insured thus assured Same day and
                                        appointments are available 7 days a week. Get Transparent pricing
                                        The satisfaction guarantee, your satisfaction is our goal, if you
                                        are not satisfied we will endeavor to make it right. Secure and
                                        seamless payment through the app 24/7 customer care through email,
                                        chat or phone Let Mesee take care of your home chores needs, so
                                        you can be freed in order for you to focus on more important
                                        issues.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default MeseeIntroduction